module.exports = __webpack_public_path__ + "static/media/BrokenFile.ddb74392.svg";